import { client } from './API';

export const uploadImageToComment = ({ communityId, cardId, data }) => {
  const formData = new FormData();
  formData.append('photo-path', data.blob(), data.filename());

  return client.post(`/v1/${communityId}/ix/nodes/${cardId}/images-in-comments`, formData, {
    headers: { Accept: '*/*', 'Content-Type': 'multipart/form-data' },
  });
};
